/* ROSA ECK custom.js – eigenes JavaScript des Shops (defer, am Ende von layout/theme.liquid geladen).
   2026-09-17 (Etappe 4): vorher drei Inline-Skripte in theme.liquid.
   Inline geblieben sind bewusst: Notch-Skript (re-painted), Wishlist-Bubble und Header-align() in sections/header.liquid. */

/* ============================================================
   ROSA ECK: Mobile Search – Tastatur sofort öffnen (iOS-fest)
   iOS oeffnet die Tastatur nur, wenn focus() in der Tap-Geste auf
   ein bereits sichtbares Feld faellt. Broadcast blendet das echte
   Suchfeld aber erst spaeter ein. Loesung: im Tap zuerst ein
   unsichtbares Dummy-Feld fokussieren (Tastatur geht auf), dann den
   Fokus aufs echte Feld uebergeben, sobald es sichtbar ist.
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('summary');
    if (!summary || !summary.closest('header-search-popdown')) return;
    var details = summary.closest('details');
    if (!details || details.open) return; // nur beim Oeffnen reagieren
    var input = details.querySelector('input[type="search"]');
    if (!input) return;

    // 1) Tastatur garantiert in der Geste oeffnen (fokussierbares Dummy)
    var decoy = document.createElement('input');
    decoy.type = 'text';
    decoy.tabIndex = -1;
    decoy.setAttribute('aria-hidden', 'true');
    decoy.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;border:0;padding:0;margin:0;font-size:16px;background:transparent;z-index:-1;';
    document.body.appendChild(decoy);
    decoy.focus();

    // 2) Popdown selbst oeffnen (Broadcast bekommt trotzdem das toggle-Event)
    e.preventDefault();
    details.open = true;

    // 3) Fokus aufs echte Feld uebergeben, sobald sichtbar -> Tastatur bleibt offen
    var n = 0;
    (function handover() {
      var ready = input.getClientRects().length > 0 &&
                  getComputedStyle(input).visibility !== 'hidden';
      if (ready) {
        input.focus({ preventScroll: true });
        try { var v = input.value; input.value = ''; input.value = v; } catch (_) {}
        if (decoy.parentNode) decoy.remove();
      } else if (++n < 40) {
        requestAnimationFrame(handover);
      } else if (decoy.parentNode) {
        decoy.remove();
      }
    })();
  }, true);
})();

/* ============================================================
   ROSA ECK: Judge.me - automatisch erzeugte Bewertungs-Titel
   ausblenden. Gibt die Kundin keinen eigenen Titel ein, setzt
   Judge.me den abgeschnittenen Textanfang als Headline (z. B.
   "Sehr schnelle Lieferung und tolles"). Erkennung: Titel ist
   Praefix des Bewertungstexts -> Titel ausblenden. Gilt fuer
   altes (jdgm-) und neues (jm-) Widget.
   ============================================================ */
(function () {
  function fixTitles() {
    document.querySelectorAll('.jdgm-rev__title, .jm-review-content__title').forEach(function (el) {
      if (el.dataset.reTitleChecked) return;
      el.dataset.reTitleChecked = '1';
      var t = el.textContent.trim().replace(/[.…]+$/, '').trim();
      if (t.length < 8) return;
      var node = el.parentElement;
      for (var depth = 0; depth < 5 && node; depth++, node = node.parentElement) {
        var ps = node.querySelectorAll('p, .jdgm-rev__body');
        for (var i = 0; i < ps.length; i++) {
          var b = ps[i];
          if (b === el || el.contains(b) || b.contains(el)) continue;
          var bt = b.textContent.trim();
          if (bt.length > t.length && bt.indexOf(t) === 0) {
            el.style.display = 'none';
            return;
          }
          if (bt.length > t.length) return; // echter Body gefunden, kein Praefix -> echter Titel
        }
      }
    });
  }
  var scheduled = false;
  var obs = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; fixTitles(); });
  });
  function init() {
    fixTitles();
    obs.observe(document.body, { childList: true, subtree: true });
  }
  // Nur Produktseite und Bewertungsseite (vorher Liquid-Bedingung in theme.liquid)
  function gate() {
    if (document.body.classList.contains('template-product') || location.pathname.indexOf('/pages/reviews') !== -1 || document.querySelector('.jdgm-widget, .jdgm-all-reviews-widget, .jdgm-all-reviews-page')) init();
  }
  if (document.readyState !== 'loading') gate();
  else document.addEventListener('DOMContentLoaded', gate);
})();

/* ROSA ECK 2026-09-18: Wishlist-Herz-Animation (Pop/Funken) lebt jetzt in
   assets/wishlist.js (eigener Wishlist-Worker, Swish-App ersetzt). */

/* ============================================================
   ROSA ECK: Popover-Fallback fuer Browser ohne Popover-API (iOS < 17).
   Versandkosten- und Frage-Karte nutzen popovertarget; dort, wo der
   Browser das nicht kann, oeffnet/schliesst dieses Skript per Klasse
   .re-pop-open (CSS in custom-re.css, Block "Popover-Fallback").
   In modernen Browsern passiert hier nichts.
   ============================================================ */
(function () {
  if ('popover' in HTMLElement.prototype) return;
  function closeAll(except) {
    document.querySelectorAll('.re-pop-open').forEach(function (el) { if (el !== except) el.classList.remove('re-pop-open'); });
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[popovertarget]');
    if (trigger) {
      var pop = document.getElementById(trigger.getAttribute('popovertarget'));
      if (!pop) return;
      e.preventDefault();
      if (trigger.getAttribute('popovertargetaction') === 'hide') { pop.classList.remove('re-pop-open'); return; }
      closeAll(pop);
      pop.classList.toggle('re-pop-open');
      return;
    }
    if (!e.target.closest('.re-pop-open')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();

/* ROSA ECK 2026-09-30: Passende Kollektionen (snippets/re-related-collections) - Scroll-Hinweis.
   Setzt re-relcol--fits (alles passt, zentrieren) bzw. re-relcol--more (rechts kommt noch etwas,
   CSS blendet den Rand weich aus). Der Related-Block wird nachgeladen, daher MutationObserver. */
(function () {
  function update(el) {
    var over = el.scrollWidth - el.clientWidth > 4;
    var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
    el.classList.toggle('re-relcol--fits', !over);
    el.classList.toggle('re-relcol--more', over && !atEnd);
  }
  function init() {
    var els = document.querySelectorAll('.re-relcol--related');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].reInit) {
        els[i].reInit = true;
        els[i].addEventListener('scroll', function () { update(this); }, { passive: true });
      }
      update(els[i]);
    }
  }
  var queued = false;
  function queue() { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; init(); }); } }
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  window.addEventListener('resize', queue);
  if (window.MutationObserver) new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ROSA ECK 2026-10-02: "Passt gut dazu"-Wischzeile - Pfeile fuer Maus-Geraete (Lukas: muss auch am
   Desktop bedienbar sein). Haengt zwei Knoepfe neben die Zeile (nicht hinein: der Warenkorb ersetzt
   den Zeileninhalt per API). Sichtbar nur, wenn die Zeile ueberlaeuft und in der Richtung noch
   etwas kommt; CSS zeigt sie nur bei hover/pointer:fine. */
(function () {
  var SEL = '.product__block.upsell-products .product__upsell, .cart__widget__products[data-upsell-products]';
  var ICON = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 2l5 5-5 5"/></svg>';
  function update(row) {
    var nav = row.reNav; if (!nav) return;
    var over = row.scrollWidth - row.clientWidth > 4;
    nav[0].hidden = !over || row.scrollLeft <= 4;
    nav[1].hidden = !over || row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    // Verlauf am Rand (CSS, nur wo die Zeile nicht bis zum Bildschirmrand laeuft)
    row.classList.toggle('re-upsell--more-l', !nav[0].hidden);
    row.classList.toggle('re-upsell--more-r', !nav[1].hidden);
    // erste SICHTBARE Karte (ausverkaufte sind per CSS ausgeblendet); Lage relativ zum Host messen
    var imgs = row.querySelectorAll('.product-upsell__image'), h = 0;
    for (var k = 0; k < imgs.length && !h; k++) h = imgs[k].offsetHeight;
    var host = row.parentElement.getBoundingClientRect();
    var top = Math.round(row.getBoundingClientRect().top - host.top + (h || row.clientHeight) / 2) + 'px';
    if (nav[0].style.top !== top) { nav[0].style.top = top; nav[1].style.top = top; }
  }
  function make(row, dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 're-upsell-arrow re-upsell-arrow--' + (dir < 0 ? 'prev' : 'next');
    b.setAttribute('aria-label', dir < 0 ? 'Zurück' : 'Weiter');
    b.innerHTML = ICON;
    if (dir < 0) b.firstChild.style.transform = 'scaleX(-1)';
    b.hidden = true;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' });
    });
    return b;
  }
  function init() {
    var rows = document.querySelectorAll(SEL);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      // ROSA ECK 2026-10-26: Im offenen Warenkorb-Drawer sperrt das Theme das Seiten-Scrollen
      // (vendor.js, Bibliothek scroll-lock). Deren touchmove-Pruefung nimmt den naechsten
      // [data-scroll-lock-scrollable]-Bereich, sonst den Drawer, und blockiert die Geste, sobald
      // der Finger beim seitlichen Wischen 1-2 px nach oben/unten abweicht. Als eigener
      // scrollbarer Bereich markiert, prueft sie die Zeile selbst und laesst seitliches Wischen durch.
      if (!row.hasAttribute('data-scroll-lock-scrollable')) row.setAttribute('data-scroll-lock-scrollable', '');
      if (!row.reNav && row.parentElement) {
        row.parentElement.classList.add('re-upsell-host');
        row.reNav = [make(row, -1), make(row, 1)];
        row.parentElement.appendChild(row.reNav[0]);
        row.parentElement.appendChild(row.reNav[1]);
        row.addEventListener('scroll', function () { update(this); }, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(queue).observe(row);
      }
      update(row);
    }
  }
  var queued = false;
  function queue() { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; init(); }); } }
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  window.addEventListener('resize', queue);
  if (window.MutationObserver) new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ============================================================
   ROSA ECK 2026-10-23: Ein-Klick-Set (snippets/re-set.liquid)
   Schickt das Set-Formular ueber den Theme-Warenkorb (gleicher Weg
   wie der Hauptknopf: Ladeanzeige, Fehler, Drawer geht auf). Ohne
   Drawer bleibt der normale Formular-Post an /cart/add.
   ============================================================ */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-re-set-form]')) return;
    if (!window.theme || !window.theme.hasCartDrawer) return;
    e.preventDefault();
    var knopf = form.querySelector('[data-re-set-add]');
    document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: knopf }, bubbles: false }));
  });
})();
